export default __webpack_public_path__ + "static/media/noNFTCollection.94ce7117.gif";